function knowledgeAdviceSlider() {
  const sliders = document.querySelectorAll(".knowledge-advice__list .splide");

  if (!sliders.length) return;

  sliders.forEach(el => {
    // Prevent double initialization
    if (el.dataset.splideInitialized === "true") return;

    const options = {
      type: "slide",
      autoWidth: false,
      perPage: 1,
      perMove: 1,
      gap: 16,
      mediaQuery: "min",
      pagination: false,
      speed: 500,
      keyboard: true,
      breakpoints: {
        768: {
          destroy: true,
          arrows: false
        }
      }
    };

    try {
      new Splide(el, options).mount();
      el.dataset.splideInitialized = "true";
    } catch (e) {
      // Fail gracefully without breaking the rest of the page
      console.error("[product-categories] Failed to initialize Splide:", e);
    }
  });
}

function videoSlider() {
  const sliders = document.querySelectorAll(".video__list .splide");

  if (!sliders.length) return;

  sliders.forEach(el => {
    // Prevent double initialization
    if (el.dataset.splideInitialized === "true") return;

    const options = {
      type: "slide",
      autoWidth: false,
      perPage: 1,
      perMove: 1,
      gap: 16,
      mediaQuery: "min",
      pagination: false,
      speed: 500,
      keyboard: true,
      breakpoints: {
        768: {
          destroy: true,
          arrows: false
        }
      }
    };

    try {
      new Splide(el, options).mount();
      el.dataset.splideInitialized = "true";
    } catch (e) {
      // Fail gracefully without breaking the rest of the page
      console.error("[product-categories] Failed to initialize Splide:", e);
    }
  });
}

document.addEventListener("DOMContentLoaded", function() {
  knowledgeAdviceSlider();
  videoSlider();
});
